import React from 'react';
import Reflux from 'reflux';
import {Button, Row, Col, Modal, Radio, Select, Input, Table, message} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew, DisplayForm} from '../../components';
import {openNotice, config} from 'Utils';
import {getDetail, exportId} from '../../service/preOrder';
import moment from 'moment';
import {detail} from '../../service/purchaseUnit'


class PreOrderDetail extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['订单详情'],
            key: 0,
            selectedRowKeys: [],
            rows: [],
            resultData: [],
            resultData2: [],
            resultData3: [],
            total: 1,
            searchObj: {
                headerId: parseInt(this.props.params.headerId),
                s: 1000,
                p: 1
            },
            visible: false,
            value: '',
            passId: '',
            loading: true,
            ordinaryOrderFlag: false,
            terminalOrderFlag: false,
            vipOrderFlag: false,

        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);

        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.goBack = this.goBack.bind(this);
    };

    goBack() {
        hashHistory.goBack();
    }

    /*选择列表*/
    onSelectChange = (selectedRowKeys) => {
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    goOrder(value) {
        let self = this;
        var resultData2 = [...this.state.resultData2];
        Object.assign(resultData2);

        // 数组删除指定元素
        for (var i = 0; i < resultData2.length; i++) {
            if (resultData2[i].commitQuantity2 == 0 || !resultData2[i].commitQuantity2) {
                delete resultData2[i];
                // console.log(resultData2[i]);
            }
        }

        function bouncer(arr) {
            // Don't show a false ID to this bouncer.
            return arr.filter(function (val) {
                return !(!val || val === "");
            });
        }

        var x = bouncer(resultData2)
        // console.log(JSON.stringify(x));
        if (x.length == 0) {
            openNotice('warning', '请确认数量');
            return
        }
        window.sessionStorage.setItem('passParse', JSON.stringify(x));
        if (value == 1) {
            self.goView(`/order/addConventional/6`);
        }
        if (value == 2) {
            self.goView(`/order/addProject/6`);
        }
        if (value == 3) {
            self.goView(`/order/addPartners/6`);
        }
    }

    /*筛选*/
    setFilterParam(name, value) {
    };

    /*筛选重置*/
    advanceReset() {
    };

    /* 筛选确认 */
    advanceSubmit(form) {
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        this.setState({loading: true});
        // var x ={
        // 	headerId:parseInt(this.props.params.headerId),
        // 	p:1,
        // 	s:10
        // }
        var obj = this.state.searchObj;
        getDetail(obj).then(result => {
            if (result.status) {
                this.setState({
                    resultData: result.data.data,
                    rows: result.data.data,
                    resultData2: result.data.data,
                    loading: false,
                    total: result.data.total,
                })
                detail(
                    result.data.data[0].buyCompanyId
                ).then(result => {
                    if (result.status) {
                        this.setState({
                            ordinaryOrderFlag: result.data.ordinaryOrderFlag == 'Y' ? true : false,
                            terminalOrderFlag: result.data.terminalOrderFlag == 'Y' ? true : false,
                            vipOrderFlag: result.data.vipOrderFlag == 'Y' ? true : false
                        });
                    } else {
                        message.error(result.message);
                    }
                })
                // console.dir(result.data);
            } else {
                message.error(result.message);
            }
        })
    }


    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
        var passId = this.props.params;
        this.setState({passId: passId});
    }

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    handleOk = () => {
        this.setState({visible: false});
    }

    handleCancel = () => {
        this.setState({visible: false});
    }


    handleChange() {

    }

    /*导出*/
    export() {
        var x = parseInt(this.props.params.headerId);
        let url = `${config.server}/api/v1/dms/tgReserveOrder/exportTgOrder?headerId=${x}`;
        window.open(url);
        // exportId(x).then(res => {
        // 	console.log(res)

        // })
    }

    /*导出*/
    exportChange() {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/tgOrder/exportTgOrder?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    onChange = (record, index, e) => {

        var num = record.requestQuantity - record.commitQuantity;
        // if (num > 1000000) {
        // 	num = 1000000;
        // }
        if (e.target.value > num) {
            e.target.value = num;
        }
        var resultData3 = JSON.parse(JSON.stringify(this.state.resultData2));
        resultData3[index].commitQuantity2 = e.target.value;
        this.setState({resultData2: resultData3});
    }

    render() {
        var self = this;
        const {opts, key, rows, total, searchObj, selectedRowKeys, visible, resultData, loading, ordinaryOrderFlag, terminalOrderFlag, vipOrderFlag} = this.state;

        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'proCode'
                }, {
                    title: '物料描述',
                    dataIndex: 'proDesc'
                },
                {
                    title: '库存属性',
                    dataIndex: 'stockType'
                },
                {
                    title: '牌价',
                    dataIndex: 'showPrice'
                },
                // {
                //     title: '销售单价',
                //     dataIndex: 'sellPrice'
                // },
                {
                    title: '装箱数',
                    dataIndex: 'packageQuantity'
                },
                {
                    title: '单位',
                    dataIndex: 'unit'
                },
                {
                    title: '请求数量',
                    dataIndex: 'requestQuantity'
                },
                {
                    title: '已提交数量',
                    dataIndex: 'commitQuantity'
                },
                {
                    title: '提交数量',
                    dataIndex: 'commitQuantity2',
                    render: (text, index, record) => {
                        var num = index.requestQuantity - index.commitQuantity;
                        return (
                            <Input min='0' type='number' max={num} style={{width: 100}}
                                   onChange={this.onChange.bind(this, index, record)}/>
                        )
                    }
                },
                {
                    title: '最小起订量',
                    dataIndex: 'minQuantity'
                },
                {
                    title: '产品线',
                    dataIndex: 'proLine',
                    render: (text) => {
                        if (text == '01' || text == '元器件') {
                            return <span>{'元器件'}</span>
                        }
                        ;
                        if (text == '02' || text == '电工') {
                            return <span>{'电工'}</span>
                        }
                        ;
                        if (text == '03' || text == '电表') {
                            return <span>{'电表'}</span>
                        }
                        ;
                        if (text == '04' || text == '变频器') {
                            return <span>{'变频器'}</span>
                        }
                        ;
                        if (text == '05' || text == '天e') {
                            return <span>{'天e'}</span>
                        }
                        ;
                        if (text == '06' || text == 'TG精品') {
                            return <span>{'TG精品'}</span>
                        }
                        ;
                    }
                }
            ],
            rows
        };
        let hasData = false;
        if (resultData.length > 0) {
            hasData = true;
        }
        const displayData = [
            {label: '预订单编号', value: hasData ? resultData[0].headerId : ''},
            {label: '流程编号', value: hasData ? resultData[0].flowCode : ''},
            {label: '申请日期', value: hasData ? moment(parseInt(resultData[0].createdDate)).format('YYYY-MM-DD') : ''},
            {label: '经销商编号', value: hasData ? resultData[0].customerCode : ''},
            {label: '经销商名称', value: hasData ? resultData[0].customerName : ''},
            {label: '购货单位', value: hasData ? resultData[0].buyCompanyName : ''},
            {label: '渠道', value: hasData ? resultData[0].channel : ''},
            {label: '提货地点', value: hasData ? resultData[0].orgName : ''}
        ];
        return (
            <div className="dms-main-box">
                <div>
                    <DmsTab options={opts} defaultKey={0}>
                        <Button
                            disabled={(this.props.params.status == '已取消' || this.props.params.status == '全部已转' || !ordinaryOrderFlag) ? true : false}
                            onClick={this.goOrder.bind(this, `${1}`)}>提交常规订单</Button>
                        <Button
                            disabled={(this.props.params.status == '已取消' || this.props.params.status == '全部已转' || !terminalOrderFlag) ? true : false}
                            onClick={this.goOrder.bind(this, `${2}`)}>提交项目订单</Button>
                        <Button
                            disabled={(this.props.params.status == '已取消' || this.props.params.status == '全部已转' || !vipOrderFlag) ? true : false}
                            onClick={this.goOrder.bind(this, `${3}`)}>提交合作伙伴订单</Button>
                        <Button onClick={this.export.bind(this)}>导出</Button>
                        <Button onClick={this.goBack}>取消</Button>
                    </DmsTab>
                    <div className="dms-table-box">
                        <DisplayForm dataSource={displayData} perRow="4"/>
                        <div>
                            <DmsTab className="white-bg no-border" options={['订单商品']} defaultKey={0}/>
                            <div className="dms-table-box">
                                <TableView {...tableViewProps}/>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        )
    }
}
;
export default withRouter(PreOrderDetail);



// WEBPACK FOOTER //
// ./src/routes/preOrder/detail.js